import { useTranslation } from 'react-i18next';
import { List, Typography } from 'antd';
import { Flex, TextComponent } from '@monorepo/react-components';

import styles from './funded-rules-modal-content.module.scss';

const { Paragraph } = Typography;

const FundedRulesModalContent = () => {
  const { t } = useTranslation(['contract']);

  const rules = [
    t('contract:contract_funded_rules_modal.contract_rules.daily_loss'),
    t(
      'contract:contract_funded_rules_modal.contract_rules.minimum_profitable_days',
    ),
    t('contract:contract_funded_rules_modal.contract_rules.rollover_hours'),
    t(
      'contract:contract_funded_rules_modal.contract_rules.news_trading_limitations',
    ),
    t(
      'contract:contract_funded_rules_modal.contract_rules.restricted_practices',
    ),
    t('contract:contract_funded_rules_modal.contract_rules.slippage'),
  ];

  return (
    <Flex vertical className={styles.container}>
      <TextComponent level={6} weight={600} className={styles.title}>
        {t('contract:contract_funded_rules_modal.contract_modal.excited_times')}
      </TextComponent>
      <Paragraph>
        {t('contract:contract_funded_rules_modal.contract_modal.description')}
      </Paragraph>
      <TextComponent level={6} weight={600} className={styles.subtitle}>
        {t('contract:contract_funded_rules_modal.contract_modal.rules')}
      </TextComponent>
      <List
        className={styles.list}
        dataSource={rules}
        renderItem={(rule) => (
          <List.Item className={styles.listItem}>{rule}</List.Item>
        )}
      />
    </Flex>
  );
};

export default FundedRulesModalContent;
